<template>
  <div class="amazon-media-multiple-input">
    <div class="form-group row">
      <label
        :for="options.name"
        :class="options.fullWidth ? 'col-sm-12' : 'col-sm-3 col-form-label'"
      >
        {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-9'">
        <div class="upload-btn-wrapper" ref="dropzone">
          <button class="btn btn-info upload-button" type="button">
            Choose file(s)...
          </button>
          <input
            type="hidden"
            :name="options.name"
            :id="options.name + '-url'"
            :value="value"
          />
        </div>
        <div v-if="hasError" class="alert alert-danger my-0">
          {{ hasError }}
        </div>
        <br />
        <template v-if="!options.displayImages">
          <div v-for="(val, index) in value" :key="index" class="feedback">
            <i class="fa fa-file"></i> {{ val.fileName }} |
            <a
              v-show="val"
              :href="'https://roscon.s3.amazonaws.com/' + val.key"
              target="_blank"
              class="text-info"
              ><i class="fa fa-search"></i> Preview</a
            >
            |
            <span
              class="interactive-cursor text-danger"
              @click="deleteImage(val)"
              ><i class="fa fa-times"></i> Remove</span
            ><br />
          </div>
        </template>
        <draggable
          v-model="valArray"
          @end="validate(valArray)"
          v-else-if="draggable"
        >
          <div class="defect-image" v-for="(val, index) in value" :key="index">
            <span class="defect-image-handle fa fa-bars"></span>
            <span
              @click="deleteImage(val)"
              class="defect-image-delete fa fa-trash red"
            ></span>
            <img
              :key="val.key"
              target="_blank"
              class="amazon-preview img-fluid my-1"
              :src="'https://roscon.s3.amazonaws.com/' + val.key"
            />
          </div>
        </draggable>
        <div
          class="defect-image"
          v-for="(val, index) in value"
          :key="index"
          v-else
        >
          <span
            @click="deleteImage(val)"
            class="defect-image-handle fa fa-trash red"
          ></span>
          <img
            :key="val.key"
            target="_blank"
            class="amazon-preview img-fluid my-1"
            :src="'https://roscon.s3.amazonaws.com/' + val.key"
          />
        </div>
        <div class="progress" style="height: 20px;" v-show="isUploading">
          <div
            class="progress-bar progress-bar-striped progress-bar-animated"
            role="progressbar"
            :style="{ width: progress + '%' }"
          >
            {{ progress }}%
          </div>
        </div>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import Draggable from "vuedraggable";
import {
  validationClass,
  validationIcon,
  validationMessage
} from "@/util/helpers";

export default {
  name: "DefectsAmazonMediaMultipleInput",
  props: {
    value: {
      type: Array
    },
    options: {
      type: Object,
      default() {
        return {
          valid: false,
          dirty: false
        };
      }
    }
  },
  components: {
    Draggable
  },
  data() {
    return {
      progress: 0,
      draggable: false,
      isUploading: false,
      isDirty: false,
      isValid: false,
      hasError: false,
      fileTypes: {
        excel: /^(application\/(vnd.openxmlformats-officedocument.spreadsheetml.sheet))$/,
        video: /^(video\/(webm|mp4|quicktime|avi|x-ms-wmv))|(audio\/(ogg|mp3))$/,
        image: /^(image\/(gif|jpe?g|png))$/,
        pdf: /^(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)$/
      },
      valArray: [],
      validFileType: /^(image\/(gif|jpe?g|png))|(application\/(pdf|x-pdf|acrobat))|(text\/(pdf|x-pdf))|(applications\/vnd\.pdf)|(video\/(webm|mp4|quicktime|avi|x-ms-wmv))|(audio\/(ogg|mp3))|(application\/(vnd.openxmlformats-officedocument.spreadsheetml.sheet))$/,
      invalidFileTypeError:
        "Not an accepted file type. Accepted file types: JPG, PNG, GIF, PDF, WEBM, MP4, MOV, AVI, WMV, MP3, OGG and XLSX."
    };
  },
  computed: {
    height() {
      // return this.options.height || 'auto'
      return 682;
    },
    width() {
      // return this.options.width || 'auto'
      return 1024;
    },
    validationClass,
    validationIcon,
    validationMessage
  },
  async mounted() {
    this.valArray = this.value;
    if (this.options.draggable) this.draggable = true;
    if (this.options.validFileType === "image") {
      this.validFileType = this.fileTypes.image;
      this.invalidFileTypeError =
        "You must upload an image file. Accepted file types: JPG, PNG and GIF";
    } else if (this.options.validFileType === "pdf") {
      this.validFileType = this.fileTypes.pdf;
      this.invalidFileTypeError = "You must upload a PDF file.";
    } else if (this.options.validFileType === "video") {
      this.validFileType = this.fileTypes.video;
      this.invalidFileTypeError =
        "You must upload a video file. Accepted file types: WEBM, MP4, MOV, AVI, WMV, MP3 and OGG";
    } else if (this.options.validFileType === "excel") {
      this.validFileType = this.fileTypes.excel;
      this.invalidFileTypeError =
        "You must upload an excel file. Accepted file type: XLSX.";
    }
    window.fd.logging = false;
    await this.$nextTick();
    let zone = new window.FileDrop(this.$refs.dropzone, {
      iframe: {
        url: `/api/admin/media-uploader?height=${this.height}&width=${this.width}`,
        fileParam: "media",
        callbackParam: "iframeCallback"
      }
    });
    zone.multiple(true);
    let fileName = "";
    let $vm = this;
    zone.event("send", function(files) {
      $vm.isUploading = true;
      files.each(function(file) {
        fileName = file.name;
        $vm.hasError = false;
        let uploadErrors = [];
        let acceptFileTypes = $vm.validFileType;
        if (file.type.length && !acceptFileTypes.test(file.type)) {
          uploadErrors.push($vm.invalidFileTypeError);
        }
        if (file.size.length && file.size > 10000000) {
          uploadErrors.push("Filesize is too big");
        }
        if (uploadErrors.length > 0) {
          $vm.progress = 0;
          $vm.isUploading = false;
          $vm.hasError = uploadErrors.join("\n");
        } else {
          file.event("progress", function(sent, total, xhr, event) {
            $vm.progress = parseInt((sent / total) * 100, 10);
          });
          file.event("done", function(xhr) {
            $vm.progress = 0;
            $vm.isUploading = false;
            let values = $vm.value;
            let json = JSON.parse(xhr.responseText);
            values.push({
              key: json.key,
              fileName: file.name,
              fileType: json.ext
            });
            $vm.$emit("input", values);
          });
          file.event("error", function(xhr) {
            uploadErrors.push(xhr.responseText);
            $vm.hasError = uploadErrors.join("\n");
          });
          file.sendTo(
            `/api/admin/media-uploader?height=${$vm.height}&width=${$vm.width}`,
            {
              extraHeaders: true,
              method: "POST"
            }
          );
        }
      });
    });
    zone.event("iframeDone", function(json) {
      $vm.progress = 0;
      $vm.isUploading = false;
      let values = $vm.value;
      values.push({
        key: json.key,
        fileName,
        fileType: json.ext
      });
      $vm.$emit("input", values);
    });
    window.fd.addEvent(window.fd.byID("multiple"), "change", function(e) {
      zone.multiple(e.currentTarget || e.srcElement.checked);
    });
    this.validate(this.value);
  },
  methods: {
    validate(val = this.value) {
      this.$emit("input", val);
      this.isDirty = true;
      if (Array.isArray(val) && val.length) {
        this.isValid = true;
      } else if (this.options.required) {
        this.isValid = false;
      } else {
        this.isValid = true;
      }
    },
    deleteImage(image) {
      let values = this.value;
      values.splice(values.indexOf(image), 1);
      this.valArray = values;
      this.validate(values);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/inputs/DefectsAmazonMediaMultipleInput.vue